import { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

const operatorChoices = [
    {value: 'le', label: '<='},
    {value: 'lt', label: '<'},
    {value: 'ge', label: '>='},
    {value: 'gt', label: '>'},
    {value: 'eq', label: '='},
    {value: 'ne', label: '≠'},
]

export default function SmrySelect(props) {
  const { userParams, setUserParams, selectOptions, handleChange, setDisableGoButton, smryChoices, variableChoices } = props;
  const [ threshError, setThreshError ] = useState(false);

  const handleThreshChange = (event) => {
    let newThresh = event.target.value ? event.target.value : "";
    newThresh = (newThresh !== "" && (!isNaN(newThresh) || newThresh === "T" || newThresh === "-")) ? newThresh : "";
    setUserParams({ ...userParams, thresh:newThresh});
    const threshProblem = newThresh === ""; //true is error
    setThreshError(threshProblem);
    setDisableGoButton(threshProblem);
  }

  return (
    <>
      <Stack direction="row" spacing={1} sx={{ mr: 1, mt: userParams.smry ? 2 : 0 }}>
        {userParams.smry && 
          <TextField
            select
            name="smry"
            id="smry"
            label="Summary type"
            value={userParams.smry}
            onChange={handleChange}
            sx={{ "minWidth": "19ch", "& .MuiSelect-icon": { right: '7px' } }}
          >
            {selectOptions(smryChoices)}
          </TextField>
        }
        <TextField
          select
          name="variable"
          id="variable"
          label="Variable"
          value={userParams.variable}
          onChange={handleChange}
          sx={{ "& .MuiSelect-icon": { right: '7px' } }}
        >
          {selectOptions(variableChoices)}
        </TextField>
        {["cnthrs","cntdys","pcthrs",null].includes(userParams.smry) && userParams.variable !== "wx" &&
          <>
            <TextField
              select
              name="operator"
              id="operator"
              label="Comparison"
              value={userParams.operator}
              onChange={handleChange}
              sx={{ "& .MuiSelect-icon": { right: '7px' }, width: '11ch' }}
            >
              {selectOptions(operatorChoices)}
            </TextField>
            <TextField
              name="thresh"
              label="Threshold"
              value={userParams.thresh}
              onChange={handleThreshChange}
              sx={{ width: '11ch' }}
              error={threshError}
            />
          </>
        }
      </Stack>
    </>
  )
}